import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderServiceService {

  constructor() { }
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  show() {
    console.log('Loader SHOW triggered');
    this.loadingSubject.next(true);
  }

  hide() {
    console.log('Loader HIDE triggered');
    this.loadingSubject.next(false);
  }
}
